import { Clock, Calendar, CalendarDays, Link } from 'lucide-react';

const segments = [
  { id: 'daily', label: 'Daily', icon: Clock, color: 'accent' },
  { id: 'weekly', label: 'Weekly', icon: Calendar, color: 'weekly' },
  { id: 'monthly', label: 'Monthly', icon: CalendarDays, color: 'monthly' },
  { id: 'links', label: 'Links', icon: Link, color: 'tertiary' },
];

export default function HabitSegmentControl({ selected, onChange, counts }) {
  return (
    <div className="bg-surface-card/60 rounded-lg border border-border p-1 mb-4">
      <div className="flex gap-1">
        {segments.map((segment) => {
          const isSelected = selected === segment.id;
          const Icon = segment.icon;
          const count = counts[segment.id];
          const hasProgress = count?.checked !== undefined;

          // Determine styling based on segment color
          const getSelectedStyles = () => {
            if (segment.color === 'accent') return 'bg-accent text-white';
            if (segment.color === 'weekly') return 'bg-weekly text-white';
            if (segment.color === 'monthly') return 'bg-monthly text-white';
            return 'bg-text-secondary text-white';
          };

          const getIconColor = () => {
            if (isSelected) return 'text-white';
            if (segment.color === 'accent') return 'text-accent';
            if (segment.color === 'weekly') return 'text-weekly';
            if (segment.color === 'monthly') return 'text-monthly';
            return 'text-text-tertiary';
          };

          return (
            <button
              key={segment.id}
              onClick={() => onChange(segment.id)}
              className={`
                flex-1 flex items-center justify-center gap-1.5 py-2 px-2 rounded-md
                text-xs font-medium cursor-pointer border-none
                transition-all duration-200
                ${isSelected ? getSelectedStyles() : 'text-text-secondary hover:bg-surface-hover'}
              `}
            >
              <Icon size={14} className={getIconColor()} />
              <span>{segment.label}</span>
              {hasProgress ? (
                <span className={`text-[10px] ${isSelected ? 'opacity-90' : 'opacity-60'}`}>
                  {count.checked}/{count.total}
                </span>
              ) : count !== undefined ? (
                <span className={`text-[10px] ${isSelected ? 'opacity-90' : 'opacity-60'}`}>
                  {count}
                </span>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
}
